import { create } from 'zustand';

interface State {
  selectedCoupon: string | null;
  couponData: any;
  setSelectedCoupon: (value: string | null) => void;
  setCouponData: (value: any) => void;
}

export const useCouponStore = create<State>((set) => ({
  selectedCoupon: null,
  couponData: {},
  setSelectedCoupon: (value) => set(() => ({ selectedCoupon: value })),
  setCouponData: (value) => set(() => ({ couponData: value })),
}));
